import axios from "axios";

let base= process.env.VUE_APP_BASE_API;

//传送 json 的 post 请求
export const postRequest=(url,params)=>{
    return axios({
        method:'post',
        url:`${base}${url}`,
        data:params
    })
}

export const getRequest=(url,params)=>{
    return axios({
        method:'get',
        url:`${base}${url}`,
        params:params
    })
}

